exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2FGHZfJKQmGz_DISS92UMU{width:32px;height:32px;min-width:32px;min-height:32px;line-height:32px}html[dir] ._2FGHZfJKQmGz_DISS92UMU{text-align:center}._3oWm3Q8ZIgWDOCTwlmV96y{color:var(--white)}html[dir] ._2LspgM2hwGSoSBtqz4pIdn{border-radius:50%}._3QHKWFeERglQrlM6aeEVvQ{width:28px;height:28px;min-width:28px;min-height:28px;line-height:28px}html[dir] ._3QHKWFeERglQrlM6aeEVvQ{text-align:center}html[dir] ._2GOsLu7xRGlBXIC7czvT4d{border-radius:4px}", ""]);
// Exports
exports.locals = {
	"container": "_2FGHZfJKQmGz_DISS92UMU",
	"icon": "_3oWm3Q8ZIgWDOCTwlmV96y",
	"roundContainer": "_2LspgM2hwGSoSBtqz4pIdn",
	"smallContainer": "_3QHKWFeERglQrlM6aeEVvQ",
	"squaredContainer": "_2GOsLu7xRGlBXIC7czvT4d"
};